export default __webpack_public_path__ + "static/media/annie.a5d51e94.jpg";